export default "__VITE_ASSET__CH7xtkQ2__"